var genesisSample = ( function( $ ) {
	'use strict';

	var loadHomepageSlider = function() {

		if ( $( 'body.home' ).length ) {
			window.player = false;

			let tag = document.createElement( 'script' );

			tag.src = 'https://www.youtube.com/iframe_api';

			let firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );

			let $slick = $( '#homepage-slider' );

			$slick.slick({
				arrows: false,
				dots: true,
				infinite: true,
				speed: 300,
				slidesToShow: 1
			});

			$slick.on( 'click', '.slick-play-button', function( e ) {
				let video_id = $( this ).data( 'id' );
				window.player = onYouTubeIframeAPIReady( video_id );
			});

			$slick.on( 'beforeChange', function() {
				stopVideo();
			});
		}
	},

	onYouTubeIframeAPIReady = function( video_id ) {
		return new YT.Player('player-' + video_id, {
			videoId: video_id,
			events: {
				'onReady': onPlayerReady,
				'onStateChange': onPlayerStateChange
			}
		});
	},

	onPlayerReady = function( event ) {
		let embedCode = event.target.getVideoEmbedCode();
		event.target.playVideo();

		if ( document.getElementById( 'embed-code' ) ) {
			document.getElementById( 'embed-code' ).innerHTML = embedCode;
		}
	},

	onPlayerStateChange = function( event ) {
		if ( event.data === YT.PlayerState.PLAYING && ! done ) {
			setTimeout( stopVideo, 6000 );
			done = true;
		}
	},

	stopVideo = function() {
		if ( window.player ) {
			window.player.stopVideo();
		}
	},

	headerScrolling = function() {
		if ( document.body.scrollTop > 80 || document.documentElement.scrollTop > 80 ) {
			$( document.body ).addClass( 'scrolling' );
		} else {
			$( document.body ).removeClass( 'scrolling' );
		}
	},

	annualReportEvent = function() {
		$( '.nypr-annual-reports' ).on( 'click', '.nypr-annual-reports__button', function() {
			let file = $( this ).parents( '.nypr-annual-reports' )
				.find( '.nypr-annual-reports__select option:selected' )
				.val();

			window.open( file, '_blank' );
		});
	},

	// Cache for tmpl.
	cache = {},

	/**
	 * Simple JavaScript Templating
	 * John Resig - https://johnresig.com/ - MIT Licensed
	 *
	 * @param str
	 * @param data
	 * @returns {Function}
	 */
	tmpl = function tmpl( str, data ) {
		// Figure out if we're getting a template, or if we need to
		// load the template - and be sure to cache the result.
		var fn = !/\W/.test(str) ?
			cache[str] = cache[str] ||
			tmpl(document.getElementById(str).innerHTML) :

		// Generate a reusable function that will serve as a template
		// generator (and which will be cached).
		new Function( "obj",
			"var p=[],print=function(){p.push.apply(p,arguments);};" +

			// Introduce the data as local variables using with(){}
			"with(obj){p.push('" +

			// Convert the template into pure JavaScript
			str
				.replace( /[\r\t\n]/g, " " )
				.split( "<%" ).join( "\t" )
				.replace( /((^|%>)[^\t]*)'/g, "$1\r" )
				.replace( /\t=(.*?)%>/g, "',$1,'" )
				.split( "\t").join("');" )
				.split( "%>").join("p.push('" )
				.split( "\r").join("\\'" )
			+ "');}return p.join('');" );

		// Provide some basic currying to the user
		return data ? fn( data ) : fn;
	},

	thankYouTracking = function() {
		if ('/thank-you/' === location.pathname) {
			var qs = _parseQuery(location.search);

			if ('undefined' === typeof qs.level || 'undefined' === typeof qs.donation) {
				return;
			}

			var price = qs.level;

			if ('0' === price) {
				price = qs.donation.substring(1)
			}

			price = parseFloat(price);

			if (isNaN(price)) {
				return;
			}

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event':'productPurchase',
				'ecommerce' : {
					'purchase': {
						'actionField': {
							'id': 'T' + Math.random().toString(36).substr(2, 9),
							'affiliation': 'Lehrer Prize for Community Well-Being Tickets',
							'revenue': price.toString()
						},
						'products': [{
							'name': 'Lehrer Prize for Community Well-Being Tickets',
							'price': price.toString(),
							'quantity': 1
						}]
					}
				}
			});
		}
	},

	_parseQuery = function(queryString) {
		var query = {};
		var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
		for (var i = 0; i < pairs.length; i++) {
			var pair = pairs[i].split('=');
			query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
		}
		return query;
	},

	leadershipModal = function() {

		let $leadership = $( '.nypr-leadership__leader' );

		$leadership.on( 'click', 'button', function() {

			let data    = $( this ).parents( $leadership ).data( 'json' );
			let $output = tmpl( 'nypr_leadership_tmpl', data );

			$( document.body ).addClass( 'nypr-modal-open' ).append( $output );

			let $modal = $( '#nypr-leadership-modal-container' );

			$modal.on( 'click', '.nypr-leadership-modal__close', function( e ) {

				e.stopPropagation();
				$( document.body ).removeClass( 'nypr-modal-open' );
				$modal.remove();

			});

			$( document ).on( 'keydown', function( e ) {
				if (
					27 === e.keyCode
					&& $( document.body ).hasClass( 'nypr-modal-open' )
				) {
					$( document.body ).removeClass( 'nypr-modal-open' );
					$( '#nypr-leadership-modal-container' ).remove();
				}

			});

			$( document ).on( 'click', '.nypr-leadership-modal-background', function() {

				$( document.body ).removeClass( 'nypr-modal-open' );
				$( '#nypr-leadership-modal-container' ).remove();

			});
		});

	},

	/**
	 * Initialize Genesis Sample.
	 *
	 * Internal functions to execute on full page load.
	 *
	 * @since 2.6.0
	 */
	load = function() {

		thankYouTracking();
		loadHomepageSlider();
		annualReportEvent();
		leadershipModal();

		window.onscroll = function() {
			headerScrolling()
		};

	};

	// Expose the load and ready functions.
	return {
		load: load
	};

})( jQuery );

jQuery( window ).on( 'load', genesisSample.load );
